import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class LimiteFinanciacion extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;
        let props = this.props;
        let seEstaEditando = props.dataCompleto.seEstaEditando;


        errorContainer = <label className="error">
            {(errors = getFieldError('limiteFinanciacion')) ? errors.join(',') : null}</label>

        let error = (getFieldError('limiteFinanciacion')) ? true : false;

        //////////Novedad en límite de financiación////////////
        let descripcion = props.data.LimiteFinanciacion;
        let novedadLimiteFinanciacion = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadLimiteFinanciacion = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadLimiteFinanciacion != undefined) {
                const esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDescripcion == false) {
                    descripcion = novedadLimiteFinanciacion.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////
        let panel = null;

        if (props.data.accountData.LimiteFinanciacionEsModificable == true) {
            let componente = <div>
                <GenericInputValidate
                    getFieldProps={getFieldProps('limiteFinanciacion', {
                        onChange(e) {
                            me.changeInput(e);
                        },
                        rules: [{
                            required: true,
                            pattern: /^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})$|^\d{0,2}(100)?$/,
                            message: 'Debe ingresar código válido.'
                        }]
                    })}
                    id="limiteFinanciacion"
                    name="limiteFinanciacion"
                    value={descripcion}
                    className="form-control default-input"
                    autoComplete="off"
                />
                {errorContainer}
            </div>

            panel = <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                novedad={novedadLimiteFinanciacion}
                error={(error || (descripcion == undefined || descripcion == ""))}
                seEstaEditando={seEstaEditando}
                permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                textPanel={((descripcion) ? descripcion + "%" : "Sin especificar")}
                title="Límite de financiación"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadLimiteFinanciacion, 2, props.data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadLimiteFinanciacion, 3, props.data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        } else {
            panel = (
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Límite de financiación</label>
                    </div>
                    <div className="col-xs-12">
                        <label className="label-secondary" >{descripcion}</label>
                    </div>
                </div>
            );
        }

        return panel;
    }
}

export default LimiteFinanciacion;